import React from "react";
import { Radio } from "antd";

interface SelectableButtonProps {
  icon: React.ReactNode;
  label: string;
  onChange: () => void;
  selected: boolean;
  radioclick: (e: React.MouseEvent) => void;
}

const SelectableButton: React.FC<SelectableButtonProps> = ({
  icon,
  label,
  onChange,
  selected,
  radioclick,
}) => {
  return (
    <div
      onClick={onChange}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "50px",
        padding: "0 16px",
        border: "1px solid #e8e8e8",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        marginBottom: 15,
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {icon}
        <span
          style={{ marginLeft: "10px", color: "#000", fontSize: "13px", fontFamily: "Inter", fontWeight: 400, }}
        >
          {label}
        </span>
      </div>

      <Radio className="custom-radio" checked={selected} onClick={radioclick} />
    </div>
  );
};

export default SelectableButton;
